import { z } from 'zod/v4';

export const articleSchema = z.object({
  code: z.string().min(1, 'articles.validation.codeRequired'),
  name: z.string().min(1, 'articles.validation.nameRequired'),
  barcode: z.string().default(''),
  description: z.string().default(''),
  categoryId: z.string().default(''),
  family: z.string().default(''),
  subFamily: z.string().default(''),
  brand: z.string().default(''),
  unit: z.string().default('pcs'),
  // Purchase
  purchasePriceHt: z.coerce.number().min(0).default(0),
  supplierDiscount: z.coerce.number().min(0).max(100).default(0),
  // Sale — user can enter HT or TTC, the other is calculated
  salePriceHt: z.coerce.number().min(0).default(0),
  salePriceTtc: z.coerce.number().min(0).default(0),
  vatRate: z.coerce.number().min(0).max(100, 'articles.validation.vatRateInvalid').default(19),
  warehouseId: z.string().default(''),
  stockMin: z.coerce.number().default(0),
  images: z.array(z.string()).default([]),
  isActive: z.boolean().default(true),
  isInvoiceable: z.boolean().default(true),
});

export type ArticleFormData = z.infer<typeof articleSchema>;

export const categorySchema = z.object({
  name: z.string().min(1, 'articles.validation.nameRequired'),
  parentId: z.string().default(''),
});

export type CategoryFormData = z.infer<typeof categorySchema>;
